

  // Immutable hash state identifiers.
  var openModalHashStateId = '#lookBook';

  $(document).ready(function() {
      var detailsInfo = $('.lookbook-wrapper .look');
      var detailKey = 0;
      var dataFrame = [];

      $('.look').on('click', function(e) {
          window.location.hash = openModalHashStateId;

          $('.image-viewer').toggleClass('visible');
          detailKey = $(this).data('id');
          dataFrame = lookDetails[detailKey];
          $('#imglooklanding').attr('src', dataFrame.fullsize);
          $('.current-count').html(detailKey+1);
          dataFrame.details.forEach(function(product){
              $('#details-container').append('<li><div class="product-name"><h3 class="detail-anchor">' + product.title + '</h3></div></li>');
          });
      });

      $('.details-trigger').click(function(e) {
          e.preventDefault();
          $('.details-wrapper').toggleClass('visible');
      });

      $('.closebtn').click(function(e) {
          e.preventDefault();
          closeLook();
      });

      $('.view-all').click(function(e) {
          e.preventDefault();
          closeLook();
      });

      $(document).on('keydown', function(e) {
        if(e.keyCode == 27) {
          if($('body.frame-open').length) {
            closeLook();
          }
          closeLook();
        }
      });

      $(document).on('keydown', function(e) {
        if(e.keyCode == 39 || e.keyCode == 40) {
          plusFrame(detailKey);
        }
        if(e.keyCode == 37 || e.keyCode == 38) {
          minusFrame(detailKey);
        }
      });

      $('.frameNav.prevFrame').on('click', function(e) {
        minusFrame(detailKey);
      });

      $('.frameNav.nextFrame').on('click', function(e) {
        plusFrame(detailKey);
      });

      function plusFrame(n) {
        if((n+1) < 70) {
          detailKey = n+1;
          showFrame(detailKey);
        } else if((n+1) == 70) {
          closeLook();
        }
      }

      function minusFrame(n) {
        if(n > 0) {
          detailKey = n - 1;
          showFrame(detailKey);
        }
      }

      function currentFrame(n) {
        showFrame(detailKey = n);
      }

      function showFrame(n) {
        $('.details-wrapper').removeClass('visible');
        $('#details-container').html('');
        $('#imglooklanding').attr('src', '');
        $('.current-count').html(n+1);
        dataFrame = lookDetails[n];
        $('#imglooklanding').attr('src', dataFrame.fullsize);
        dataFrame.details.forEach(function(product){
            $('#details-container').append('<li><div class="product-name"><h3 class="detail-anchor">' + product.title + '</h3></div></li>');
        });
      }

  });

  function closeLook() {
    //if( window.location.hash == openModalHashStateId ) {
      //window.history.back();
    //}

      $('.image-viewer').removeClass('visible');
      $('.details-wrapper').removeClass('visible');
      $('#details-container').html('');
      $('.current-count').html('');
      $('#imglooklanding').attr('src', '');
      $('body').removeClass('no-scroll');
      $('body').removeClass('frame-open');
      document.getElementsByTagName('body')[0].style.removeProperty('overflow');
      //document.getElementsByTagName('body')[0].style.overflow = 'auto';

  }

  $(window).on('hashchange', function (event) {
      if(window.location.hash != openModalHashStateId) {
        closeLook();
      }
  });
